module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.videoID !== null) ? _c('li', {
    staticClass: "rubric-option",
    class: {
      'is-active': _vm.selected, disabled: true
    },
    on: {
      "click": function($event) {
        _vm.videoID > 0 ? _vm.scoreRubric(_vm.val) : {}
      }
    }
  }, [_c('section', [(!_vm.editing) ? _c('h3', {
    staticClass: "title is-5"
  }, [_vm._v(_vm._s(_vm.header))]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.header),
      expression: "header"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Update title..."
    },
    domProps: {
      "value": (_vm.header)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.header = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.editing) ? _c('p', [_vm._v(_vm._s(_vm.desc))]) : _c('textarea', {
    directives: [{
      name: "textautosize",
      rawName: "v-textautosize"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.desc),
      expression: "desc"
    }],
    staticClass: "textarea",
    attrs: {
      "type": "text",
      "placeholder": "Update title..."
    },
    domProps: {
      "value": (_vm.desc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.desc = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "selected-container"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "disabled": false
    },
    domProps: {
      "checked": _vm.selected
    }
  })])]) : _c('li', {
    staticClass: "rubric-option",
    class: {
      'is-active': _vm.selected, disabled: true
    }
  }, [_c('section', [_c('h3', {
    staticClass: "title is-5"
  }, [_vm._v(_vm._s(_vm.header))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.desc))])]), _vm._v(" "), _c('div', {
    staticClass: "selected-container"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "disabled": false
    },
    domProps: {
      "checked": _vm.selected
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-d4d670e8"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RubricBox.vue
// module id = 1088
// module chunks = 0